module.exports = __webpack_public_path__ + "static/img/COC2021-1.07707d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-1.jpg
// module id = bJzy
// module chunks = 0